var map = {
	"./black/repository-black-da.json": 61,
	"./black/repository-black-de.json": 62,
	"./black/repository-black-ee.json": 63,
	"./black/repository-black-en.json": 64,
	"./black/repository-black-no.json": 65,
	"./black/repository-black-se.json": 66,
	"./black/template-setups-black.json": 31,
	"./grey/repository-grey-da.json": 67,
	"./grey/repository-grey-de.json": 68,
	"./grey/repository-grey-ee.json": 69,
	"./grey/repository-grey-en.json": 23,
	"./grey/repository-grey-no.json": 70,
	"./grey/repository-grey-se.json": 71,
	"./grey/template-setups-grey.json": 30,
	"./hd/repository-hd-da.json": 72,
	"./hd/repository-hd-de.json": 73,
	"./hd/repository-hd-ee.json": 74,
	"./hd/repository-hd-en.json": 75,
	"./hd/repository-hd-no.json": 76,
	"./hd/repository-hd-se.json": 77,
	"./hd/template-setups-hd.json": 32
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;